export const BUSINESS_CASE_STATES = [
  'OFFER',
  'CONTRACT',
  'DEPOSIT',
  'DEPOSIT_PAID',
  'INVOICE',
  'PAID',
] as const;
